import { Button } from '@chakra-ui/react';
import type React from 'react';

interface MigrationCtaButtonProps {
  label: string;
  onClick: () => void;
  isLoading: boolean;
}

/** The card's single call to action; only brand owners and admins ever see it. */
export const MigrationCtaButton: React.FC<MigrationCtaButtonProps> = ({
  label,
  onClick,
  isLoading,
}) => (
  <Button
    size="sm"
    colorPalette="primary"
    alignSelf="flex-start"
    whiteSpace="normal"
    textAlign="left"
    height="auto"
    py={2}
    onClick={onClick}
    loading={isLoading}
  >
    {label}
  </Button>
);
